(function fixCheckboxLabels() {
  function fixCheckboxLabel(/** @type {HTMLLabelElement} */ label) {
    if (label.getAttribute('role') === 'checkbox') {
      const inputId = label.getAttribute('for');
      if (inputId) {
        const input = document.getElementById(inputId);
        if (input instanceof HTMLInputElement && input.getAttribute('type') === 'checkbox') {
          label.setAttribute('aria-checked', input.checked ? 'true' : 'false');
        }
      }
      label.removeAttribute('role');
    }
  }

  function processAllLabels() {
    const labels = document.querySelectorAll('label.checkbox__label, label[role="checkbox"]');
    labels.forEach(fixCheckboxLabel);
  }

  function init() {
    processAllLabels();

    if (document.body) {
      const observer = new MutationObserver((mutations) => {
        let shouldProcess = false;
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'role') {
            const target = mutation.target;
            if (target instanceof HTMLLabelElement && target.getAttribute('role') === 'checkbox') {
              fixCheckboxLabel(target);
            }
          } else if (mutation.type === 'childList') {
            mutation.addedNodes.forEach((node) => {
              if (node instanceof HTMLLabelElement) {
                fixCheckboxLabel(node);
              } else if (node instanceof Element) {
                const labels = node.querySelectorAll('label.checkbox__label, label[role="checkbox"]');
                if (labels.length > 0) {
                  shouldProcess = true;
                }
              }
            });
          }
        });
        if (shouldProcess) {
          processAllLabels();
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['role']
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

